import {ChangeDetectionStrategy, Component, inject} from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslatePipe} from '@brunata-angular/util';
import {SelectBuildingTableComponent} from 'src/app/select-building/select-building-table/select-building-table.component';
import {systemInformationLink} from '@shared/route-utils';
import {Router} from '@angular/router';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, SelectBuildingTableComponent],
    template: `
        <div class="modal-header">
            <h4 class="modal-title">
                {{ 'titles_chooseSystem' | translate: 'online' : 'systems' }}
            </h4>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="activeModal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <app-select-building-table (loadBuilding)="selectBuilding($event)" />
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="activeModal.close()">
                {{ 'reporting_CLOSE' | translate }}
            </button>
        </div>
    `,
})
export class SelectBuildingModalComponent {
    readonly activeModal = inject(NgbActiveModal);
    private readonly router = inject(Router);

    selectBuilding(building: {buildingNo: string}): void {
        void this.router.navigate(systemInformationLink(building.buildingNo));
        this.activeModal.close();
    }
}
